/**
 * 日期格式化工具
 * 后端返回的时间多为 ISO 时间戳（如 2026-07-27T10:52:47.244865），
 * 页面展示统一转为“年-月-日”，更简洁直观。
 */

/**
 * 把任意时间值格式化为 YYYY-MM-DD（仅年月日）。
 * - ISO / YYYY-MM-DD 字符串：直接截取日期部分，避免 new Date() 因时区导致日期偏移
 * - 其他可解析值（时间戳数字等）：按本地时区取年月日
 * - 空值 / 无法解析：返回 fallback
 * @param {*} value 后端返回的时间字段
 * @param {string} fallback 空值或解析失败时的占位文本
 */
export function formatDate(value, fallback = '-') {
  if (value == null || value === '') return fallback
  const str = String(value).trim()
  const match = str.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (match) return match[1] + '-' + match[2] + '-' + match[3]
  const date = new Date(str)
  if (!isNaN(date.getTime())) {
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return date.getFullYear() + '-' + month + '-' + day
  }
  return fallback
}
